import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React from "react";
import { ButtonToolbar, Dropdown, ToggleButton, ToggleButtonGroup } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import { FormattedMessage, useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { FUNDING_AREA_STORE } from "../../../../common/constant";
import { SELECTED_PROGRAM } from "../../../../ducks/fundingArea";
import SurveyUtils from "../../../../utils/SurveyUtils";
import { CHART_MODE_CHART, CHART_MODE_TABLE, COMMENT, TEXT } from "../../../../ducks/collapsibleTableChart";

const GROUP_BY_QUESTION_KEY = "projectData";
const GROUP_BY_PROJECT_COLUMN_KEY = "project";
const GROUP_BY_REPORTING_YEAR_COLUMN_KEY = "reportingYear";
const GROUP_BY_REGION_COLUMN_KEY = "region";
const GROUP_BY_COUNTRY_COLUMN_KEY = "country";
const GROUP_BY_REPORTING_YEAR_QUESTION_TITLE = "Berichtszeitraum";
const GROUP_BY_PROJECT_QUESTION_TITLE = "Projektnummer";
const GROUP_BY_REGION_QUESTION_TITLE = "Region";
const GROUP_BY_COUNTRY_QUESTION_TITLE = "Land";
const GROUP_BY_REPORTING_YEAR_QUESTION_TYPE = "RADIO";
const GROUP_BY_PROJECT_QUESTION_TYPE = "RADIO";

const CollapsibleCardHeader = ({
  data,
  baseQuestionId,
  baseQuestionColId,
  baseQuestionRowId,
  baseQuestionIdentifier,
  baseColumnType,
  isSubquestion,
  baseQuestionType,
  baseQuestionTitle,
  baseQuestionKey,
  baseQuestionRowKey,
  baseQuestionColumnKey,
  baseQuestionGroupKey,
  shortcutType,
  chartMode,
  handleClickDownloadQuestion,
  handleModalOpen,
  handlePivotShortcutSubmit,
  handleSelectChartModeTable,
  handleSelectChartModeChart,
  onPercentageClick,
  onRenderBreadcrumb,
  renderBreadcrumb,
  baseQuestionString,
  groupByQuestionString,
  checked,
  percentageOn,
  status,
  periodCount,
  columns
}) => {
  const intl = useIntl();
  const selectedProgram = useSelector((state) => state[FUNDING_AREA_STORE][SELECTED_PROGRAM]);
  const isLectorateProgram = SurveyUtils.isSemesterTypeProgram(selectedProgram?.indicatorsModalDialog?.name);
  let subquestionModifiedId;

  // lookup if we have an identifer supplied otherwise take row/colIDs
  if (baseQuestionIdentifier && baseQuestionIdentifier !== "") {
    subquestionModifiedId = baseQuestionId.toString() + baseQuestionIdentifier;
  } else {
    if (
      (baseQuestionRowId !== null && typeof baseQuestionRowId !== "undefined") ||
      (baseQuestionColId !== null && typeof baseQuestionColId !== "undefined")
    ) {
      subquestionModifiedId =
        baseQuestionId.toString() +
        (baseQuestionColId ? baseQuestionColId.toString() : "0") +
        (baseQuestionRowId ? baseQuestionRowId.toString() : "0");
    } else {
      subquestionModifiedId = baseQuestionId;
    }
  }

  return (
    <>
      <ButtonToolbar className="gap-lg flex-center-between">
        {baseColumnType !== TEXT && baseColumnType !== COMMENT && (
          <ButtonGroup>
            <Button
              variant="light"
              onClick={handleSelectChartModeTable}
              active={!chartMode || chartMode === CHART_MODE_TABLE}
            >
              {intl.formatMessage({ id: "collapsible.table.label.table" })}
            </Button>
            <Button variant="light" onClick={handleSelectChartModeChart} active={chartMode === CHART_MODE_CHART}>
              {intl.formatMessage({ id: "collapsible.table.label.chart" })}
            </Button>
          </ButtonGroup>
        )}
        {baseColumnType !== TEXT && baseColumnType !== COMMENT && (!chartMode || chartMode !== CHART_MODE_CHART) && (
          <ToggleButtonGroup
            name="amount"
            type="radio"
            defaultValue={percentageOn[subquestionModifiedId] ? 2 : 1}
            title={intl.formatMessage({ id: "indicator.chart.legend.project.amount" })}
          >
            <ToggleButton variant="light" onClick={() => onPercentageClick(subquestionModifiedId, false)} value={1}>
              <FormattedMessage id="master.data.management.program.table.numerical" />
            </ToggleButton>
            <ToggleButton variant="light" onClick={() => onPercentageClick(subquestionModifiedId, true)} value={2}>
              <FormattedMessage id="master.data.management.program.table.percentage" />
            </ToggleButton>
          </ToggleButtonGroup>
        )}
        <div className="mx-auto"></div>
        {(!chartMode || chartMode !== CHART_MODE_CHART) && (
          <ButtonGroup>
            <Button
              variant="link"
              disabled={chartMode === CHART_MODE_CHART}
              onClick={() =>
                handleClickDownloadQuestion(
                  data,
                  baseQuestionId,
                  subquestionModifiedId,
                  baseQuestionString,
                  groupByQuestionString
                )
              }
            >
              <FontAwesomeIcon icon={faDownload} className="me-2" />
              {intl.formatMessage({ id: "respondents.detail.downloadButton" })}
            </Button>
          </ButtonGroup>
        )}
        {columns && columns.length > 0 && (
          <Dropdown align="end">
            <Dropdown.Toggle>{intl.formatMessage({ id: "survey.editor.matrix.column.choices" })}</Dropdown.Toggle>
            <Dropdown.Menu>{columns}</Dropdown.Menu>
          </Dropdown>
        )}
        <ButtonGroup>
          <Dropdown>
            <Dropdown.Toggle>{intl.formatMessage({ id: "collapsible.filter.pivot.button.name" })}</Dropdown.Toggle>
            <Dropdown.Menu>
              {baseColumnType !== TEXT && baseColumnType !== COMMENT && (
                <>
                  <Dropdown.Item
                    data-bs-toggle="modal"
                    data-target="#exampleModal"
                    onClick={(element, question) =>
                      handleModalOpen(
                        element,
                        question,
                        baseQuestionId,
                        baseColumnType,
                        isSubquestion,
                        baseQuestionType,
                        baseQuestionRowId,
                        baseQuestionColId,
                        baseQuestionIdentifier,
                        baseQuestionKey,
                        baseQuestionRowKey,
                        baseQuestionColumnKey,
                        baseQuestionGroupKey
                      )
                    }
                  >
                    {intl.formatMessage({ id: "collapsible.filter.pivot.button" })}
                  </Dropdown.Item>
                  <Dropdown.Item
                    active={shortcutType === GROUP_BY_REPORTING_YEAR_COLUMN_KEY}
                    onClick={() => 
                      handlePivotShortcutSubmit(
                        baseQuestionId,
                        baseQuestionColId,
                        baseQuestionRowId,
                        baseQuestionIdentifier,
                        baseColumnType,
                        isSubquestion,
                        baseQuestionType,
                        baseQuestionKey,
                        baseQuestionRowKey,
                        baseQuestionColumnKey,
                        baseQuestionGroupKey,
                        GROUP_BY_QUESTION_KEY,
                        GROUP_BY_REPORTING_YEAR_COLUMN_KEY,
                        GROUP_BY_REPORTING_YEAR_QUESTION_TITLE,
                        GROUP_BY_REPORTING_YEAR_QUESTION_TYPE,
                        GROUP_BY_REPORTING_YEAR_QUESTION_TYPE,
                        status
                      )
                    }
                  >
                    {intl.formatMessage({ id: "collapsible.filter.pivot.button.reporting.year" })}
                  </Dropdown.Item>
                </>
              )}
              <Dropdown.Item
                active={shortcutType === GROUP_BY_PROJECT_COLUMN_KEY}
                onClick={() =>
                  handlePivotShortcutSubmit(
                    baseQuestionId,
                    baseQuestionColId,
                    baseQuestionRowId,
                    baseQuestionIdentifier,
                    baseColumnType,
                    isSubquestion,
                    baseQuestionType,
                    baseQuestionKey,
                    baseQuestionRowKey,
                    baseQuestionColumnKey,
                    baseQuestionGroupKey,
                    GROUP_BY_QUESTION_KEY,
                    GROUP_BY_PROJECT_COLUMN_KEY,
                    GROUP_BY_PROJECT_QUESTION_TITLE,
                    GROUP_BY_PROJECT_QUESTION_TYPE,
                    GROUP_BY_PROJECT_QUESTION_TYPE,
                    status
                  )
                }
              >
                {intl.formatMessage({ id: "collapsible.filter.pivot.button.project" })}
              </Dropdown.Item>
              {isLectorateProgram && (
                <>
                  <Dropdown.Item
                    active={shortcutType === GROUP_BY_REGION_COLUMN_KEY}
                    onClick={() =>
                      handlePivotShortcutSubmit(
                        baseQuestionId, baseQuestionColId, baseQuestionRowId, baseQuestionIdentifier,
                        baseColumnType, isSubquestion, baseQuestionType, baseQuestionKey,
                        baseQuestionRowKey, baseQuestionColumnKey, baseQuestionGroupKey,
                        GROUP_BY_QUESTION_KEY, GROUP_BY_REGION_COLUMN_KEY,
                        GROUP_BY_REGION_QUESTION_TITLE, GROUP_BY_PROJECT_QUESTION_TYPE,
                        GROUP_BY_PROJECT_QUESTION_TYPE, status
                      )
                    }
                  >
                    {intl.formatMessage({ id: "collapsible.filter.pivot.button.region" })}
                  </Dropdown.Item>
                  <Dropdown.Item
                    active={shortcutType === GROUP_BY_COUNTRY_COLUMN_KEY}
                    onClick={() =>
                      handlePivotShortcutSubmit(
                        baseQuestionId, baseQuestionColId, baseQuestionRowId, baseQuestionIdentifier,
                        baseColumnType, isSubquestion, baseQuestionType, baseQuestionKey,
                        baseQuestionRowKey, baseQuestionColumnKey, baseQuestionGroupKey,
                        GROUP_BY_QUESTION_KEY, GROUP_BY_COUNTRY_COLUMN_KEY,
                        GROUP_BY_COUNTRY_QUESTION_TITLE, GROUP_BY_PROJECT_QUESTION_TYPE,
                        GROUP_BY_PROJECT_QUESTION_TYPE, status
                      )
                    }
                  >
                    {intl.formatMessage({ id: "collapsible.filter.pivot.button.country" })}
                  </Dropdown.Item>
                </>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </ButtonGroup>
      </ButtonToolbar>
      {renderBreadcrumb && (
        <ButtonToolbar className="bg-white border mt-2">
          <ButtonGroup className="w-100 ">{onRenderBreadcrumb()}</ButtonGroup>
        </ButtonToolbar>
      )}
    </>
  );
};

CollapsibleCardHeader.propTypes = {
  baseQuestionId: PropTypes.number,
  baseQuestionColId: PropTypes.number,
  baseQuestionRowId: PropTypes.number,
  baseQuestionIdentifier: PropTypes.string,
  isSubquestion: PropTypes.bool,
  baseQuestionTitle: PropTypes.string,
  baseQuestionSubType: PropTypes.string,
  baseQuestionType: PropTypes.string,
  baseQuestionKey: PropTypes.string,
  baseQuestionRowKey: PropTypes.string,
  baseQuestionColumnKey: PropTypes.string,
  baseQuestionGroupKey: PropTypes.string,
  staticTableCols: PropTypes.bool,
  shortcutType: PropTypes.string,
  chartMode: PropTypes.string,
  handleClickDownloadQuestion: PropTypes.func,
  handleModalOpen: PropTypes.func,
  handlePivotShortcutSubmit: PropTypes.func,
  handleSelectChartModeTable: PropTypes.func,
  handleSelectChartModeChart: PropTypes.func,
  onPercentageClick: PropTypes.func,
  onRenderBreadcrumb: PropTypes.func,
  renderBreadcrumb: PropTypes.bool,
  baseQuestionString: PropTypes.string,
  groupByQuestionString: PropTypes.string,
  checked: PropTypes.bool,
  percentageOn: PropTypes.object,
  status: PropTypes.string
};

export default CollapsibleCardHeader;
